import type { SmsConsentData } from "../../services/api";

type SmsConsentGate = Pick<SmsConsentData, "available" | "current" | "version">;

/** Ask before the operation when this version has no answer yet. */
export function smsConsentNeedsAutoPrompt(consent: SmsConsentGate): boolean {
  return consent.available && consent.current === "none" && Boolean(consent.version);
}

/**
 * Turning the switch on asks only when this version has no Yes.
 * A decline still asks. A current Yes just saves the switch.
 */
export function smsSwitchNeedsPrompt(consent: SmsConsentGate): boolean {
  return (
    consent.available &&
    consent.current !== "accepted" &&
    Boolean(consent.version)
  );
}
